module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dropdown', {
    staticClass: "event-options"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-option-horizontal clickable options-trigger",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu show",
    attrs: {
      "slot": "options"
    },
    slot: "options"
  }, [_c('li', [_c('ftp-sync-button')], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6bf88ca8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/individual_records/Menu.vue
// module id = 1053
// module chunks = 1